import React from 'react'
import Fragment from '../common/fragment'


function FragmentBR(props) {
  return (
    <Fragment pos="rr" {...props}>
      <p>
El Muñeco será una Esfinge que/ desde lo alto de una azotea/ pregunte a los
transeúntes: ¿qué sucederá mañana cuando los animales despierten sumergidos en
electrodos y otras formas de resurrección a la carta?, ¿dónde está Edipo, tan fiel a su
deseo como a su desgracia?, ¿alguien en Salamanca puede hablarme del Cristo
Negro y sus agonías?, ¿es la oscuridad tan sagrada como la claridad del día?
      </p>
    </Fragment>
  )
}


export default FragmentBR
